<template>
  <div id="app" v-if="shouLock">
    <header-nav v-if='isLoginAlive'></header-nav>
    <router-view v-if="isRouterAlive"/>
    <footer-page></footer-page>
  </div>
</template>

<script>
import headerNav from '@/components/header'
import footerPage from '@/components/footer'
export default {
  name: 'App',
  components: {
    headerNav,
    footerPage
  },
  provide () {
    return {
      reload: this.reload// 调用reload方法
    }
  },
  data () {
    return {
      isRouterAlive: true, // 一开始router-view为true
      isLoginAlive: true,
      shouLock: true
    }
  },
  created () {
    //判断是广告跳转
    console.log(this.$route.query.isAd)
    if (this.$route.query.isAd) {
      let strKU = this.$route.query.r1
      let strRR = this.$route.query.r2
      let ku = strKU.replace(/qzc/g, '&')
      let rr = strRR.replace(/qzc/g, '&')
      localStorage.setItem('keywordUrl', ku)
      localStorage.setItem('remote_referer', rr)
      localStorage.setItem('isAd', this.$route.query.isAd)
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.isLoginAlive = false
      // 在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
      this.$nextTick(() => {
        this.isRouterAlive = true
        this.isLoginAlive = true
      })
    },
  },

  mounted () {
    if (this.$route.path === '/pay') {
      this.shouLock = false
    } else {
      this.shouLock = true
    }
  }

};
</script>

<style>
#app {
  font-family: Microsoft YaHei, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f8f8f8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue